import * as React from "react";

import { SkeletonGenerator, Margins, Row, Column } from "@ui/Atoms";

export const MyCleaningsDashboardViewSkeleton = () => (
  <Margins xs={["base_x4", "base_x4", null, null]}>
    <div>
      <Row>
        <Column md={6}>
          <SkeletonGenerator
            count={1}
            shape="rectVertical"
            customHeight={180}
          />
        </Column>
        <Column md={6}>
          <SkeletonGenerator
            count={1}
            shape="rectVertical"
            customHeight={180}
          />
        </Column>
      </Row>
      <SkeletonGenerator
        count={2}
        shape="rectVertical"
        randomHeight={120}
        noGutter
      />
      <SkeletonGenerator count={1} shape="rectVertical" randomHeight={120} />
      <SkeletonGenerator count={1} shape="rectVertical" randomHeight={200} />
      <SkeletonGenerator count={1} shape="rectVertical" randomHeight={200} />
    </div>
  </Margins>
);
